module.exports = __webpack_public_path__ + "static/img/5.76ed1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/5.png
// module id = tEhM
// module chunks = 1